import { createContext, useState } from "react";

export const InventoryEditProductFormContext = createContext();

export const InventoryEditProductFormContextProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);

    // const [customField, setCustomField] = useState([]);

    const defaultFormErrors = {
        productName: '',
        images: '',
        mrp: '',
        discount: '',
        sellingPrice: '',
        hsnCode: '',
        taxCode: '',
        country: '',
        color: '',
        size: '',
        stock: '',
        skuCode: '',
        width: '',
        height: '',
        weight: '',
        keywords: '',
        tags: ''
    }

    const [formErrors, setFormErrors] = useState(defaultFormErrors);

    const [selectedChart, setSelectedChart] = useState({});
    
    const defaultProductDetails = {
        productName: '',
        productDescription: ''
    }

    const defaultPricesAndTaxes = {
        mrp: '',
        discount: '',
        sellingPrice: '',
        hsnCode: '',
        taxCode: {},
        country: 'India'
    }

    const defaultSpecifications = {
        color: '',
        size: '',
    };

    const defaultInventoryInputs = {
        stock: '',
        // stockPrimary: '',
        skuCode: ''
    }

    const defaultPackagingDetails = {
        width: '',
        height: '',
        weight: ''
    }

    const [productDetails, setProductDetails] = useState(defaultProductDetails);

    const [specifications, setSpecifications] = useState(defaultSpecifications);
    const [productSpecifications, setProductSpecifications] = useState([]);
    const [additionalSpecifications, setAdditionalSpecifications] = useState([]);

    const [pricesAndTaxes, setPricesAndTaxes] = useState(defaultPricesAndTaxes);

    const [inventoryInputs, setInventoryInputs] = useState(defaultInventoryInputs);

    const [packagingDetails, setPackagingDetails] = useState(defaultPackagingDetails);

    const [keywords, setKeywords] = useState([]);

    // const [sizeVariants, setSizeVariants] = useState([]);

    // const [colorVariants, setColorVariants] = useState([]);

    // const [inventory, setInventory] = useState([]);

    const [productImages, setProductImages] = useState([]);

    const [selectedCategories, setSelectedCategories] = useState([]);

    const [selectedCollections, setSelectedCollections] = useState([]);

    const [selectedCustomCollections, setSelectedCustomCollections] = useState([]);

    const [selectedTags, setSelectedTags] = useState([]);

    const [productsList, setProductsList] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedProductType, setSelectedProductType] = useState('');

    const contextValue = {
        productDetails,
        setProductDetails,
        specifications,
        setSpecifications,
        pricesAndTaxes,
        setPricesAndTaxes,
        packagingDetails,
        setPackagingDetails,
        keywords,
        setKeywords,
        // customField,
        // setCustomField,
        additionalSpecifications,
        setAdditionalSpecifications,
        // sizeVariants,
        // setSizeVariants,
        // colorVariants,
        // setColorVariants,
        // inventory,
        // setInventory,
        inventoryInputs,
        setInventoryInputs,
        productImages,
        setProductImages,
        selectedCategories,
        setSelectedCategories,
        selectedCollections,
        setSelectedCollections,
        selectedCustomCollections,
        setSelectedCustomCollections,
        selectedTags,
        setSelectedTags,
        formErrors,
        setFormErrors,
        defaultFormErrors,
        loading,
        setLoading,
        productSpecifications,
        setProductSpecifications,
        selectedChart,
        setSelectedChart,
        
        selectedCategory,
        setSelectedCategory,
        selectedProductType,
        setSelectedProductType,
        productsList,
        setProductsList,
    };

    return (
        <InventoryEditProductFormContext.Provider value={ contextValue }>
            { children }
        </InventoryEditProductFormContext.Provider>
    );
}
